import { experimentalStyled } from '@material-ui/core/styles';


const CreativeLoveLogo = (props) => (
  <img src="/static/CreativeLoveLogo.png" width={props.width} />
);

export default CreativeLoveLogo;
